// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"4a07423f","952":"9264ad91"}[chunkId] + ".chunk.js";
};